export default {
  primary: '#2FAA33',
  secundary: '#37CD3F',

  black: '#000',
  darker: '#111',
  dark: '#282828',
  regular: '#666',
  light: '#DCDCDC',
  lighter: '#F5F5F5',
  white: '#FFF',
  red: '#e50000',
  yellow: '#FACA07',
  transparent: 'rgba(0, 0, 0, 0)',
};
